export enum AccountLocatorType {
HardCoded,
Expression,
Conditions,
DynamicGroup,
SpecificAccount,
ChildAccounts,
}
